const VI_LANGUAGE_CODE = "vi-VN";

const getLanguageCode = (language) => {
  if (!language || language === "all") return undefined;
  return typeof language === "string" ? language : language.code;
};

const findTranslationName = (translations = [], languageCode) => {
  if (!languageCode) return undefined;

  const translation = translations.find(
    (item) =>
      item.languageCode &&
      item.languageCode.toLowerCase() === languageCode.toLowerCase() &&
      item.name
  );

  return translation && translation.name;
};

export const getVinWonderTagGroupDisplayName = (item = {}, language) => {
  const translations = item.translations || [];
  const currentLanguageCode = getLanguageCode(language);
  const currentLanguageName = findTranslationName(
    translations,
    currentLanguageCode
  );
  const vietnameseName = findTranslationName(translations, VI_LANGUAGE_CODE);
  const fallbackTranslation = translations.find((translation) => translation.name);

  return (
    currentLanguageName ||
    vietnameseName ||
    (fallbackTranslation && fallbackTranslation.name) ||
    item.name
  );
};

export const normalizeVinWonderTagGroups = (data = [], language) =>
  data.map((item) => ({
    ...item,
    name: getVinWonderTagGroupDisplayName(item, language),
  }));
